import React from "react";
import { Tooltip, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowUpCircleIcon from "mdi-react/ArrowUpCircleIcon";
import IconComponent from "components/items/icon-component";
import { ApplicationItemWithWidth } from "app/main/applications/components/application-item";
import { green } from "@material-ui/core/colors";

const title = "Urgent Treatment Approval Granted";

const useStyles = makeStyles(() => ({
  icon: {
    color: green[700],
    marginRight: "4px",
  },
}));

const UrgentApprovedIcon = ({
  show,
  size = 20,
  iconOnly,
}) => {
  const classes = useStyles();

  if (!show) {
    return null;
  }

  const UrgentApprovedIconComponent = React.forwardRef((props, ref) => (
    <div className={classes.icon} ref={ref} {...props}>
      <IconComponent icon={<ArrowUpCircleIcon />} size={size} />
    </div>
  ));

  if (iconOnly) {
    return <UrgentApprovedIconComponent />;
  }

  return (
    <Box className={classes.icon}>
      <Tooltip title={title}>
        <UrgentApprovedIconComponent />
      </Tooltip>
    </Box>
  );
};

export const UrgentApprovedIconItem = ({ show }) => <ApplicationItemWithWidth icon={<UrgentApprovedIcon iconOnly show={show} />} label={title} content="Yes" />;

export default UrgentApprovedIcon;
